module.exports = __webpack_public_path__ + "static/media/hand-holding-heart-solid.e2cff3cf.svg";